import "./LandingModal.css";

const LandingModal = ({ title, description, onOpenApp, onContinueWeb }) => {

  return (
    <>
      <div className="login-container">
        <div className="login-img-container">
          <img
            src="/images/onboarding-page-image.webp"
            alt="NimbleBash celebration"
            className="login-celebration-img"
          />
        </div>
        <div className="jlm-modal">
          <h2 className="jlm-title">{title}</h2>
          <p className="jlm-description">{description}</p>

          <button className="jlm-primary" onClick={onOpenApp}>
            Open App
          </button>

          <button className="jlm-secondary" onClick={onContinueWeb}>
            Continue on Web
          </button>
        </div>
      </div>
    </>
  );
};

export default LandingModal;
